import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TypeSpecimen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6H2v16h16v-2H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H6v16h16V2zm-5.37 12.5-.8-2.3H12.2l-.82 2.3H9.81l3.38-9h1.61l3.38 9h-1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 7.17-1.31 3.72h2.69l-1.3-3.72z"
  }));
});
TypeSpecimen.displayName = 'TypeSpecimen';
export var TypeSpecimenDimensions = {
  height: 24,
  width: 24
};